import { useState } from "react";
import { translateAPI } from "../axios/translate-axios";
import { toast } from "react-toastify";

const TOAST_IDS = {
    missingId: "translation-missing-id",
    translateError: "translation-error",
};

const BASE_TOAST_OPTIONS = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
};

const useTranslation = () => {
    const [translatedCache, setTranslatedCache] = useState({});
    const [translatedBlock, setTranslatedBlock] = useState("");

    const translateText = async (document_id, selectedLanguage) => {
        const cacheKey = `${document_id}_${selectedLanguage}`;
        if (translatedCache[cacheKey]) {
            setTranslatedBlock(translatedCache[cacheKey]);
            return;
        }

        // Call the translation API
        if (!document_id) {
            console.error("document_id is missing.");
            toast.error("Document ID is missing.", {
                ...BASE_TOAST_OPTIONS,
                toastId: TOAST_IDS.missingId,
            });
            return;
        }

        try {
            const response = await translateAPI.post(
                `?document_id=${document_id}&target_language=${selectedLanguage}`,
                null,
                { headers: { "Content-Type": "application/json" } }
            );
            const translatedText = response.data.document.translated_text[selectedLanguage];
            setTranslatedCache(translatedCache => ({
                ...translatedCache,
                [cacheKey]: translatedText 
            }));
            setTranslatedBlock(translatedText);
        } catch (error) {
            console.error("Error translating document:", error);
            toast.error("Error translating document.", {
                ...BASE_TOAST_OPTIONS,
                toastId: TOAST_IDS.translateError,
            });
        }
    };

    // Function to clear cache
    const clearTranslationCache = () => {
        setTranslatedCache({});
        setTranslatedBlock("");
    };

    return { translatedBlock, setTranslatedBlock, translateText, clearTranslationCache };
};

export default useTranslation;
